var _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackdropSr1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 59,
    viewBox: "0 0 56 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    fill: "#0CCE6B",
    fillOpacity: 0.23
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackdropSr1);
export default __webpack_public_path__ + "static/media/backdrop-SR1.6e8f08c2c579a41ea404cccd90836ec7.svg";
export { ForwardRef as ReactComponent };